import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Pricing() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [selectedPlan, setSelectedPlan] = useState<'pro' | 'basic'>('pro');
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 25,
    s: 12
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="pricing" className="py-12 bg-surface border-t border-white/5 relative overflow-hidden" aria-label="Precios y planes" data-id="element-216">
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-217">
        {/* Countdown Timer */}
        <FadeIn data-id="element-218">
          <div className="text-center mb-8" data-id="element-219">
            <h3 className="text-xl md:text-2xl font-bold text-white mb-4" data-id="element-220">
              ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
            </h3>
            <div className="flex items-center justify-center gap-2 md:gap-4 text-3xl md:text-5xl font-heading font-bold text-gold" data-id="element-221">
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-222">
                {formatTime(timeLeft.h)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-223">
                  hs
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-224">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-225">
                {formatTime(timeLeft.m)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-226">
                  min
                </span>
              </div>
              <span className="text-gray-500 pb-6" data-id="element-227">:</span>
              <div className="bg-surfaceLight border border-white/10 rounded-xl px-4 py-3 min-w-[80px]" data-id="element-228">
                {formatTime(timeLeft.s)}
                <span className="text-sm block text-gray-400 font-body font-normal mt-1" data-id="element-229">
                  seg
                </span>
              </div>
            </div>
            <p className="text-red-400 mt-4 font-medium" data-id="element-230">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </FadeIn>

        <FadeIn data-id="element-231">
          <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-8" data-id="element-232">
            ELEGÍ TU <span className="text-gold" data-id="element-233">PACK</span>
          </h2>
        </FadeIn>

        <div id="elegir-plan" className="max-w-2xl mx-auto mb-12" role="radiogroup" aria-label="Seleccionar plan" data-id="element-234">
          {/* Progress Bar */}
          <FadeIn delay={0.05} data-id="element-235">
            <div className="mb-6" data-id="element-236">
              <div className="flex justify-between text-sm mb-2" data-id="element-237">
                <span className="text-red-400 font-bold flex items-center gap-2" data-id="element-238">
                  <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" data-id="element-239"></span>
                  Cupos al precio de lanzamiento — Quedan pocos
                </span>
                <span className="text-gray-400" data-id="element-240">68%</span>
              </div>
              <div className="w-full bg-surfaceLight rounded-full h-2.5 overflow-hidden border border-white/5" data-id="element-241">
                <div className="bg-gold h-2.5 rounded-full" style={{
                width: '68%'
              }} data-id="element-242"></div>
              </div>
              <p className="text-xs text-gray-500 mt-2 text-center" data-id="element-243">
                68% de los cupos al precio de lanzamiento ya tomados
              </p>
            </div>
          </FadeIn>

          {/* Basic Plan */}
          <FadeIn delay={0.1} data-id="element-244">
            <button onClick={() => setSelectedPlan('basic')} role="radio" aria-checked={selectedPlan === 'basic'} aria-label="Sistema Maestro de Aluminio — $19.990 ARS" className={`w-full text-left rounded-2xl p-6 mb-4 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'basic' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-245">
              <div className="flex items-start gap-4" data-id="element-246">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'basic' ? 'border-gold' : 'border-gray-500'}`} data-id="element-247">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-248"></div>}
                </div>

                <div className="flex-1 min-w-0" data-id="element-249">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-250">
                    <div data-id="element-251">
                      <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-252">
                        <span data-id="element-253">📘</span> SISTEMA MAESTRO DE ALUMINIO
                      </h3>
                      <p className="text-gray-400 text-sm mb-3" data-id="element-254">
                        6 Tomos + 4 Bonos
                      </p>
                      <div className="bg-surfaceLight/50 px-3 py-2 rounded-lg border border-white/5 text-xs text-gray-300 inline-block" data-id="element-255">
                        <span className="font-semibold text-white" data-id="element-256">
                          Ideal para:
                        </span>{' '}
                        Carpinteros, armadores y dueños de taller
                      </div>
                    </div>
                    <div className="sm:text-right shrink-0" data-id="element-257">
                      <span className="text-gray-500 line-through text-sm block" data-id="element-258">
                        $45.000
                      </span>
                      <span className="text-3xl font-bold text-white font-heading" data-id="element-259">
                        $19.990
                      </span>
                      <span className="text-sm text-gray-400 ml-1" data-id="element-260">ARS</span>
                    </div>
                  </div>
                </div>
              </div>
            </button>
          </FadeIn>

          {/* Pro Plan */}
          <FadeIn delay={0.2} data-id="element-261">
            <div className="relative" data-id="element-262">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10" data-id="element-263">
                <span className="bg-gold text-background font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider" data-id="element-264">
                  Más Elegido ⭐
                </span>
              </div>
              <button onClick={() => setSelectedPlan('pro')} role="radio" aria-checked={selectedPlan === 'pro'} aria-label="Sistema Maestro + Fichas de Taller — $29.990 ARS" className={`w-full text-left rounded-2xl p-6 transition-all duration-300 border-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold ${selectedPlan === 'pro' ? 'border-gold shadow-[0_0_25px_rgba(212,168,67,0.15)] bg-surfaceLight/60' : 'border-white/10 bg-background hover:border-white/20'}`} data-id="element-265">
                <div className="flex items-start gap-4" data-id="element-266">
                  <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${selectedPlan === 'pro' ? 'border-gold' : 'border-gray-500'}`} data-id="element-267">
                    {selectedPlan === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-gold" data-id="element-268"></div>}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-269">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" data-id="element-270">
                      <div data-id="element-271">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2 mb-1" data-id="element-272">
                          <span data-id="element-273">🏆</span> SISTEMA MAESTRO + FICHAS DE TALLER{' '}
                          <span className="text-yellow" data-id="element-274">⭐</span>
                        </h3>
                        <p className="text-gold text-sm font-medium mb-3" data-id="element-275">
                          6 Tomos + 4 Bonos + Sistema de Trabajo en 1 Minuto
                        </p>
                        <div className="bg-gold/5 px-3 py-2 rounded-lg border border-gold/20 text-xs text-gray-300 inline-block" data-id="element-276">
                          <span className="font-semibold text-white" data-id="element-277">
                            Ideal para:
                          </span>{' '}
                          Talleres con ayudantes, producción en volumen, trabajo
                          sin supervisión
                        </div>
                      </div>
                      <div className="sm:text-right shrink-0" data-id="element-278">
                        <span className="text-gray-500 line-through text-sm block" data-id="element-279">
                          $55.000
                        </span>
                        <span className="text-3xl font-bold text-gold font-heading" data-id="element-280">
                          $29.990
                        </span>
                        <span className="text-sm text-gold/70 ml-1" data-id="element-281">ARS</span>
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-282">
            <a id="cta-comprar" href={selectedPlan === 'pro' ? 'https://fegion.shop/cart/46850730492043:1' : 'https://fegion.shop/cart/46850728263819:1'} className="block w-full mt-6 py-5 text-center rounded-2xl font-bold text-background bg-gold hover:bg-gold/90 transition-colors shadow-lg uppercase tracking-wider text-lg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-283">
              {selectedPlan === 'pro' ? '→ QUIERO EL PACK COMPLETO CON FICHAS' : '→ QUIERO MI SISTEMA MAESTRO AHORA'}
            </a>
          </FadeIn>
        </div>

        {/* Comparison Table */}
        <FadeIn delay={0.2} data-id="element-284">
          <div className="max-w-4xl mx-auto mb-12" data-id="element-285">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 text-center" data-id="element-286">
              🔩 ¿QUÉ AGREGA EL SISTEMA DE TRABAJO EN 1 MINUTO?
            </h3>
            <p className="text-gray-400 text-center mb-6" data-id="element-287">
              El sistema completo para que tu taller funcione incluso cuando vos
              no estás
            </p>
            <p className="text-sm text-gray-400 mb-2 md:hidden text-center" data-id="element-288">
              ← Deslizá para ver la tabla →
            </p>
            <div className="overflow-x-auto pb-4" data-id="element-289">
              <table className="w-full min-w-[600px] text-left border-collapse" data-id="element-290">
                <thead data-id="element-291">
                  <tr data-id="element-292">
                    <th className="p-4 border-b border-white/10 text-gray-300 font-semibold bg-surfaceLight/30 rounded-tl-xl" data-id="element-293">
                      Situación en el taller
                    </th>
                    <th className="p-4 border-b border-white/10 text-red-400 font-semibold bg-red-500/5" data-id="element-294">
                      ❌ Sin Fichas
                    </th>
                    <th className="p-4 border-b border-white/10 text-gold font-semibold bg-gold/5 rounded-tr-xl" data-id="element-295">
                      ✅ Con Fichas
                    </th>
                  </tr>
                </thead>
                <tbody className="text-sm md:text-base" data-id="element-296">
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-297">
                    <td className="p-4 text-gray-300" data-id="element-298">
                      Ayudante pregunta el descuento
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-299">
                      Buscás en el manual
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-300">
                      Mira la tabla en la pared. Listo.
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-301">
                    <td className="p-4 text-gray-300" data-id="element-302">
                      Va a comprar herrajes al proveedor
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-303">
                      Se olvida piezas
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-304">
                      Lleva la lista exacta por tipología
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-305">
                    <td className="p-4 text-gray-300" data-id="element-306">
                      Operario nuevo en el taller
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-307">
                      No puede trabajar solo
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-308">
                      Sigue las fichas sin preguntar nada
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-309">
                    <td className="p-4 text-gray-300" data-id="element-310">
                      Necesitás presupuestar en la visita
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-311">
                      Esperás volver al taller
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-312">
                      Calculador analógico en la mano
                    </td>
                  </tr>
                  <tr className="border-b border-white/5 hover:bg-white/5 transition-colors" data-id="element-313">
                    <td className="p-4 text-gray-300" data-id="element-314">
                      Taller trabaja sin el maestro
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-315">
                      Todo para
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium" data-id="element-316">
                      El sistema funciona igual
                    </td>
                  </tr>
                  <tr className="hover:bg-white/5 transition-colors" data-id="element-317">
                    <td className="p-4 text-gray-300 rounded-bl-xl" data-id="element-318">
                      Identificar un perfil desconocido
                    </td>
                    <td className="p-4 text-gray-400 bg-red-500/5" data-id="element-319">
                      Duda y pregunta
                    </td>
                    <td className="p-4 text-white bg-gold/5 font-medium rounded-br-xl" data-id="element-320">
                      Ficha de identificación en la pared
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </FadeIn>

        {/* Kit Includes */}
        <FadeIn delay={0.3} data-id="element-321">
          <div className="max-w-4xl mx-auto mb-12 bg-surfaceLight/30 rounded-3xl p-8 border border-white/5" data-id="element-322">
            <h3 className="text-2xl font-bold text-white mb-8 text-center" data-id="element-323">
              ✅ EL SISTEMA DE TRABAJO EN 1 MINUTO INCLUYE:
            </h3>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-324">
              {['Tablas de descuento de bolsillo para pegar en la sierra', 'Recetario de herrajes por tipología lista para el proveedor', 'Fichas de identificación de perfiles para el banco de armado', 'Planillas de corte imprimibles para el operario', 'Optimizador de barras anti-desperdicio', 'Calculador analógico de precio rápido para visitas de obra', 'Checklist de salida del taller antes de cada entrega', 'Hoja de ruta de producción paso a paso'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-background/50 p-4 rounded-xl border border-white/5" data-id="element-325">
                  <span className="text-gray-300" data-id="element-326">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Testimonials */}
        <FadeIn delay={0.4} data-id="element-327">
          <div className="max-w-5xl mx-auto mb-12" data-id="element-328">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-10 text-center" data-id="element-329">
              ❤️ MÁS TALLERES QUE YA LO TIENEN
            </h3>
            <div className="grid md:grid-cols-2 gap-6" data-id="element-330">
              {[{
              name: 'Jorge R.',
              loc: '📍 Córdoba',
              plan: 'Sistema Maestro completo',
              text: 'Pegué las tablas de descuento en la sierra y mi ayudante cortó solo toda la semana. No me llamó una sola vez para preguntar medidas.'
            }, {
              name: 'Marcelo P.',
              loc: '📍 Rosario',
              plan: 'Taller de Aluminio',
              text: 'El Tomo 5 de instalación me eliminó las filtraciones. No tuve un solo reclamo en los últimos 3 meses.'
            }, {
              name: 'Carlos A.',
              loc: '📍 Buenos Aires',
              plan: 'Carpintero independiente',
              text: 'Con el Tomo 6 me di cuenta que en algunos trabajos estaba perdiendo plata. Ahora presupuesto con margen real.'
            }, {
              name: 'Diego P.',
              loc: '📍 Mendoza',
              plan: 'Dueño de taller',
              text: 'El Atlas de Planos fue lo que más me sorprendió. Le di los planos a mi ayudante nuevo y fabricó la primera ventana sin preguntarme nada.'
            }].map((t, i) => <div key={i} className="bg-surfaceLight p-6 rounded-2xl border border-white/5" data-id="element-331">
                  <div className="flex gap-1 mb-3" data-id="element-332">
                    {[...Array(5)].map((_, j) => <span key={j} className="text-yellow text-sm" data-id="element-333">
                        ★
                      </span>)}
                  </div>
                  <p className="text-gray-300 mb-4 italic" data-id="element-334">"{t.text}"</p>
                  <div className="text-sm" data-id="element-335">
                    <span className="font-bold text-white" data-id="element-336">{t.name}</span>
                    <span className="text-gray-500 mx-2" data-id="element-337">|</span>
                    <span className="text-gray-400" data-id="element-338">{t.loc}</span>
                    <span className="text-gray-500 mx-2" data-id="element-339">|</span>
                    <span className="text-gold text-xs" data-id="element-340">{t.plan}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        {/* Guarantee */}
        <FadeIn delay={0.5} data-id="element-341">
          <div className="max-w-3xl mx-auto bg-surfaceLight/50 rounded-3xl p-8 md:p-12 border border-white/5 text-center" data-id="element-342">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/5 mb-6 text-4xl" data-id="element-343">
              🛡️
            </div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-344">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h3>
            <p className="text-gray-300 text-lg mb-6" data-id="element-345">
              Abrís los tomos. Los usás en el taller. Si en 7 días no es lo que
              esperabas:
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 mb-6 text-white font-medium" data-id="element-346">
              <div className="flex items-center justify-center gap-2" data-id="element-347">
                <span className="text-green-400" data-id="element-348">✅</span> devolución del 100%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-349">
                <span className="text-green-400" data-id="element-350">✅</span> sin formularios, sin
                drama.
              </div>
            </div>
            <div className="inline-block bg-background px-4 py-2 rounded-lg border border-white/10 text-sm text-gray-400" data-id="element-351">
              Tasa de devoluciones: menos del 1%.
            </div>
          </div>
        </FadeIn>

        {/* FAQ */}
        <FadeIn delay={0.6} data-id="element-352">
          <div className="max-w-3xl mx-auto mt-12" data-id="element-353">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-354">
              ❓ LO QUE MÁS NOS PREGUNTAN
            </h3>
            <div className="space-y-4" role="list" data-id="element-355">
              {[{
              q: '¿Sirve si trabajo con líneas que no son Herrero ni Módena?',
              a: 'Los conceptos de descuento, armado e instalación aplican a cualquier línea del mercado. Las tablas de Herrero y Módena te dan la lógica que después adaptás a cualquier perfil similar.'
            }, {
              q: '¿Cómo recibo el material?',
              a: '100% digital. Apenas completás el pago recibís un email con acceso inmediato a todos los PDFs. Lo descargás en tu celular, tablet o computadora y lo tenés para siempre.'
            }, {
              q: '¿Puedo imprimirlo?',
              a: 'Sí. Todo el sistema está diseñado para imprimirse. Las tablas, fichas y checklists están pensados para estar plastificados en la pared del taller o en el maletín de obra.'
            }, {
              q: '¿Sirve si soy nuevo en la carpintería de aluminio?',
              a: 'Sí. Si estás empezando, es la forma más rápida de aprender bien desde el principio. Si ya tenés experiencia, vas a encontrar el sistema que te faltaba para trabajar con más velocidad y menos errores.'
            }, {
              q: '¿Tiene garantía real?',
              a: 'Sí. 7 días de garantía total. Si no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas.'
            }].map((faq, i) => <div key={i} className="bg-surfaceLight border border-white/5 rounded-xl overflow-hidden" role="listitem" data-id="element-356">
                  <button onClick={() => setOpenFaq(openFaq === i ? null : i)} className="w-full px-6 py-4 text-left flex items-center justify-between focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-gold" aria-expanded={openFaq === i} aria-controls={`faq-answer-${i}`} data-id="element-357">
                    <span className="font-medium text-white pr-4" data-id="element-358">{faq.q}</span>
                    <ChevronDown className={`w-5 h-5 text-gray-400 transition-transform shrink-0 ${openFaq === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-359" />
                  </button>
                  {openFaq === i && <div id={`faq-answer-${i}`} className="px-6 pb-4 text-gray-400" role="region" aria-label={faq.q} data-id="element-360">
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}